<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner uncentered">
      <div class="edit-popup edit-popup--banks">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            {{ currentBank.type === 'new' ? 'Add' : 'Edit' }} Bank
          </div>
          <div @click="closeModalBank" class="edit-popup__close">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <form action="javascript:void(0)" class="edit-popup--bank__form">
          <div class="form-block form-block_first">
            <div class="form-block_title">
              <span>Bank of Beneficiary</span>
            </div>
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">Bank Name:</div>
                <div
                  class="row_input"
                  :class="[
                    'form-control-wrap',
                  ]">
                  <input
                    type="text"
                    v-model="currentBank.name"
                    Placeholder="Bank Name:"
                    class="form-control" />
                </div>
              </div>
              <div class="form-block_row">
                <div class="row_name">Contract Type:</div>
                <div class="row_input">
                  <ClassicSelect
                      class="contract-type-select"
                      :selected-item="selectedContractType"
                      :items="contractTypes"
                      custom-width="100%"
                      @select-item="currentBank.contractType = $event.id"/>
                </div>
              </div>
            </div>
            <div class="form-block_row">
              <div class="row_name">Currencies:</div>
              <div class="row_input">
                <v-select
                  v-model="currentBank.availableCurrencies"
                  :options="CURRENCIES"
                  :clearable="false"
                  :close-on-select="false"
                  :searchable="true"
                  class="bank-currencies-select"
                  placeholder="Select currencies"
                  multiple>
                  <template #open-indicator>
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                    </svg>
                  </template>
                  <template #no-options>
                    No currencies found
                  </template>
                </v-select>
              </div>
            </div>
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">
                  Short <br />
                  Bank Name:
                </div>
                <div
                  class="row_input"
                  :class="[
                    'form-control-wrap',
                  ]">
                  <input
                    type="text"
                    v-model="currentBank.shortName"
                    Placeholder="Short Bank Name:"
                    class="form-control" />
                </div>
              </div>
              <div class="form-block_row">
                <div class="row_name">SWIFT:</div>
                <div
                  class="row_input"
                  :class="[
                    'form-control-wrap',
                  ]">
                  <input
                    type="text"
                    v-model="currentBank.swift"
                    Placeholder="SWIFT:"
                    class="form-control" />
                </div>
              </div>
            </div>
            <div class="form-block_row">
              <div class="row_name">Address:</div>
              <div
                class="row_input"
                :class="[
                  'form-control-wrap',
                ]">
                <textarea
                  style="resize: none"
                  type="text"
                  v-model="currentBank.bankAddress"
                  class="form-control" />
              </div>
            </div>
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">
                  Account <br> Number:
                </div>
                <div
                    class="row_input"
                    :class="[
                    'form-control-wrap',
                  ]">
                  <input
                      type="text"
                      v-model="currentBank.accountNumber"
                      Placeholder="---- ---- ---- ----"
                      class="form-control" />
                </div>
              </div>
              <div class="form-block_row">
                <div class="row_name">Sort Code:</div>
                <div
                    class="row_input"
                    :class="[
                    'form-control-wrap',
                  ]">
                  <input
                      type="text"
                      v-model="currentBank.sortCode"
                      Placeholder="--- ---"
                      class="form-control" />
                </div>
              </div>
            </div>
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">
                  Routing <br> Number:
                </div>
                <div
                    class="row_input"
                    :class="[
                    'form-control-wrap',
                  ]">
                  <input
                      type="text"
                      v-model="currentBank.routingNumber"
                      Placeholder="---- ---- ---- ----"
                      class="form-control" />
                </div>
              </div>
              <div class="form-block_row">
                <div class="row_name">Account <br> Type:</div>
                <div
                    class="row_input"
                    :class="[
                    'form-control-wrap',
                  ]">
                  <input
                      type="text"
                      v-model="currentBank.accountType"
                      Placeholder="Type"
                      class="form-control" />
                </div>
              </div>
            </div>
          </div>

          <div class="form-block form-block_second">
            <div class="form-block_title">
              <span>Beneficiary</span>
            </div>
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">IBAN Account:</div>
                <div
                  class="row_input"
                  :class="[
                    'form-control-wrap',
                  ]">
                  <input
                    type="text"
                    v-model="currentBank.ibanAccount"
                    Placeholder="IBAN Account:"
                    class="form-control" />
                </div>
              </div>
              <div class="form-block_row">
                <div class="row_name">Company name:</div>
                <div
                  class="row_input"
                  :class="[
                    'form-control-wrap',
                  ]">
                  <input
                    type="text"
                    v-model="currentBank.companyName"
                    Placeholder="Company name:"
                    class="form-control" />
                </div>
              </div>
            </div>
            <div class="form-block_row">
              <div class="row_name">Address:</div>
              <div
                class="row_input"
                :class="[
                  'form-control-wrap',
                ]">
                <textarea
                  style="resize: none"
                  type="text"
                  v-model="currentBank.beneficiaryAddress"
                  class="form-control" />
              </div>
            </div>
          </div>

          <div class="form-block form-block_third">
            <div class="form-block_row-wrap">
              <div class="form-block_row">
                <div class="row_name">Sort:</div>
                <div
                    class="row_input"
                    :class="[
                    'form-control-wrap',
                  ]">
                  <input
                      type="number"
                      Placeholder="sort number"
                      v-model="currentBank.priority"
                      class="form-control" />
                </div>
              </div>

                <div class="form-block_row">
                  <div class="row_name">Public Invoices:</div>
                  <div class="switch">
                    <label class="switch-label">
                      <input type="checkbox"
                             v-model="currentBank.publicInvoices"/>
                      <span class="switch-inp"></span>
                    </label>
                  </div>
                </div>
            </div>
          </div>
          <div class="form-block form-block_fourth">
            <div class="form-block__reminder-content">
              <div class="form-block__row-heading">
                Payment reminder:
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  USD
                </div>
                <div :class="[
                      'js-ckeditor',
                    ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderUSD"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  EUR
                </div>
                <div :class="[
                      'js-ckeditor',
                    ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderEUR"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  GBP
                </div>
                <div :class="[
                    'js-ckeditor',
                  ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderGBP"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  CAD
                </div>
                <div :class="[
                    'js-ckeditor',
                  ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderCAD"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  CHF
                </div>
                <div :class="[
                    'js-ckeditor',
                  ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderCHF"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  AUD
                </div>
                <div :class="[
                    'js-ckeditor',
                  ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderAUD"
                      :config="editorConfig"></editor>
                </div>
              </div>
              <div class="form-block__reminder-item">
                <div class="form-block__row-heading">
                  AED
                </div>
                <div :class="[
                    'js-ckeditor',
                  ]">
                  <editor
                      :editor="editor"
                      v-model="currentBank.paymentReminderAED"
                      :config="editorConfig"></editor>
                </div>
              </div>
            </div>
          </div>
          <div class="form-block_btn">
            <div class=""></div>
            <div class="form-control-group">
              <button @click="changeBank" type="button" class="btn btn--green">
                <span>{{
                  currentBank.type === 'new' ? 'Add Bank' : 'Edit change'
                }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '@/utilites/ckeditor'
import ClassicSelect from '@/components/UI/ClassicSelect/ClassicSelect.vue'
import { CURRENCIES } from '@/common/helpers/currency'

export default {
  components: {
    editor: CKEditor.component,
    ClassicSelect,
  },
  name: 'ATModalBanks',
  props: {
    currentBank: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      validateForm: {
        isName: false,
        isShortName: false,
        isSwift: false,
        isBankAddress: false,
        isIbanAccount: false,
        isCompanyName: false,
        isBeneficiaryAddress: false,
        isPriority: false,
        routingNumber: false,
        accountType: false,
        accountNumber: false,
        sortCode: false,
        paymentReminderUSD: null,
        paymentReminderEUR: null,
        paymentReminderGBP: null,
        paymentReminderCAD: null,
        paymentReminderCHF: null,
        paymentReminderAUD: null,
        paymentReminderAED: null,
        publicInvoices: true,
      },
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Type here',
      },
      contractTypes: [
        {id: 'TZ', name: 'Tanzania'},
        {id: 'UAE', name: 'UAE'},
      ],
      CURRENCIES,
    }
  },
  computed: {
    selectedContractType() {
      return this.contractTypes.find((item) => item.id === this.currentBank.contractType) || this.contractTypes[0]
    },
  },
  methods: {
    closeModalBank() {
      this.$emit('closeModalBankParameters', false)
    },
    changeBank() {
      this.currentBank.paymentReminderUSD ? null : this.currentBank.paymentReminderUSD = '';
      this.currentBank.paymentReminderEUR ? null : this.currentBank.paymentReminderEUR = '';
      this.currentBank.paymentReminderGBP ? null : this.currentBank.paymentReminderGBP = '';
      this.currentBank.paymentReminderCAD ? null : this.currentBank.paymentReminderCAD = '';
      this.currentBank.paymentReminderCHF ? null : this.currentBank.paymentReminderCHF = '';
      this.currentBank.paymentReminderAUD ? null : this.currentBank.paymentReminderAUD = '';
      this.currentBank.paymentReminderAED ? null : this.currentBank.paymentReminderAED = '';
      this.$emit('changeBankParameters', this.currentBank)
      this.closeModalBank()
    },
  },
  mounted() {},
}
</script>

<style scoped>
.contract-type-select,
.contract-type-select >>> .select-wrapper {
  width: 100%;
}

.bank-currencies-select {
  width: 100%;
}

.bank-currencies-select >>> .vs__dropdown-toggle {
  min-height: 3.6rem;
  padding: 0.3rem 0.5rem;
  border-color: #bcbcbc;
  background-color: #fff;
}

.bank-currencies-select >>> .vs__selected-options {
  gap: 0.4rem;
  padding: 0;
}

.bank-currencies-select >>> .vs__selected {
  margin: 0;
  padding: 0.4rem 0.7rem;
  border: 1px solid #d6e3c1;
  border-radius: 3px;
  background-color: #f4f8ed;
  color: #2e2e2e;
  font-size: 1.2rem;
  line-height: 1.4rem;
}

.bank-currencies-select >>> .vs__deselect {
  margin-left: 0.6rem;
  fill: #606060;
}

.bank-currencies-select >>> .vs__search,
.bank-currencies-select >>> .vs__search:focus {
  width: 0 !important;
  min-width: 8rem;
  margin: 0;
  padding: 0 0.5rem;
  font-size: 1.2rem;
}

.bank-currencies-select >>> .vs__actions {
  padding: 0 0.7rem;
}

.bank-currencies-select >>> .vs__actions .icon-chevron {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
}

.bank-currencies-select.vs--open >>> .vs__actions .icon-chevron {
  transform: rotate(180deg);
}

.bank-currencies-select >>> .vs__dropdown-option {
  padding: 0.3rem 1.2rem;
  color: rgba(27, 27, 27, 0.6);
  font-size: 1.2rem;
}

.bank-currencies-select >>> .vs__dropdown-option--highlight {
  background-color: #f4f8ed;
  color: #1b1b1b;
}

.bank-currencies-select >>> .vs__dropdown-option--selected {
  color: #1b1b1b;
  font-weight: 600;
}
</style>
